// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1VcCl","detailsBorder":"styles_detailsBorder__2lYjY"};